import { render } from "./ModalUserInvite.vue?vue&type=template&id=291d20fe&scoped=true"
import script from "./ModalUserInvite.vue?vue&type=script&lang=js"
export * from "./ModalUserInvite.vue?vue&type=script&lang=js"

import "./ModalUserInvite.vue?vue&type=style&index=0&id=291d20fe&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291d20fe"]])

export default __exports__